import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=7801d7a8&"
import script from "./bill.vue?vue&type=script&lang=js&"
export * from "./bill.vue?vue&type=script&lang=js&"
import style0 from "./bill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Option: require('/home/runner/work/myody_front/myody_front/components/option/Option.vue').default,Select: require('/home/runner/work/myody_front/myody_front/components/select/Select.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,TableInvoice: require('/home/runner/work/myody_front/myody_front/components/table/TableInvoice.vue').default})
